import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'default' | 'lg' | 'xl';
  scrollToOffer?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'default',
  scrollToOffer = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold text-white transition-all duration-300 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 active:translate-y-0 focus:outline-none focus:ring-4 focus:ring-green-300';
  const sizeStyles = {
    default: 'px-5 py-2.5 text-base',
    lg: 'px-7 py-3.5 text-lg',
    xl: 'px-8 py-4 text-xl'
  };
  const colorStyles = 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500';
  const handleClick = (e: React.MouseEvent) => {
    if (scrollToOffer) {
      e.preventDefault();
      const element = document.getElementById('purchase');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <a href="https://checkout.edulabs.online/cart/45636720885921:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${colorStyles}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-245">
      <span data-id="element-246">{children}</span>
      <ArrowRight className="ml-2 h-5 w-5 animate-pulse" data-id="element-247" />
    </a>;
}